import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import PageBase from '../components/PageBase';
import LoraConfigForm from '../components/LoraConfigForm';
import Loading from '../components/Loading';
import * as loraConfigActions from '../redux/modules/loraConfigs';
import i18n from '../translations/i18n';
import * as packetboxActions from '../redux/modules/packetboxes';

/*
PropTypes / DefaultProps
 */
const propTypes = {
  modifyLoraConfig: PropTypes.func,
  fetchLoraConfig: PropTypes.func,
  fetchPacketbox: PropTypes.func,
  unloadCurrentLoraConfig: PropTypes.func,
  unloadCurrentPacketbox: PropTypes.func,
  loraConfig: PropTypes.object,
  assignedPacketbox: PropTypes.any,
  currentUser: PropTypes.object,
  params: PropTypes.any,
  t: PropTypes.func,
};

const defaultProps = {
  loraConfig: {},
};

class LoraConfigModify extends React.Component {
  constructor(props) {
    super(props);
    this.dataReady = false;
  }
  /*
    Lifecycle methods
   */
  componentWillMount() {
    const id = this.props.params.splat;
    this.props.fetchLoraConfig(id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loraConfig && nextProps.loraConfig.paketbox_id && !nextProps.assignedPacketbox) {
      this.props.fetchPacketbox(nextProps.loraConfig.paketbox_id);
    }

    if (nextProps.loraConfig && !nextProps.loraConfig.paketbox_id) {
      this.dataReady = true;
    }

    if (nextProps.loraConfig && nextProps.loraConfig.paketbox_id && nextProps.assignedPacketbox) {
      this.dataReady = true;
    }
  }

  componentWillUnmount() {
    this.props.unloadCurrentLoraConfig();
    this.props.unloadCurrentPacketbox();
  }

  /*
    Custom methods
   */
  onModifyLoraConfig = (values) => {
    this.props.modifyLoraConfig(values);
  };

  render() {
    const { loraConfig, assignedPacketbox } = this.props;

    if (!this.dataReady) {
      return (
        <PageBase title={translate('modify_lora_config')}>
          <Loading />
        </PageBase>
      );
    }
    const isPaketboxConfigured = assignedPacketbox && assignedPacketbox.state !== 'UNCONFIGURED';

    let disableSave = true;
    // Enable save if user is super admin and if the paketbox is not configured
    if (
      this.props.currentUser &&
      this.props.currentUser.role === 'SUPER_ADMIN' &&
      !isPaketboxConfigured
    ) {
      disableSave = false;
    }

    return (
      <PageBase title={this.props.t('modify_lora_config')}>
        <LoraConfigForm
          onSubmit={this.onModifyLoraConfig}
          isModify
          initialValues={loraConfig}
          disableSave={disableSave}
        />
      </PageBase>
    );
  }
}

LoraConfigModify.defaultProps = defaultProps;
LoraConfigModify.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    assignedPacketbox: state.packetboxes.current,
    loraConfig: state.loraConfigs.current,
    currentUser: state.auth.current,
  };
}

const actions = Object.assign({}, loraConfigActions, packetboxActions);
const extended = translate(['translations'], { i18n })(LoraConfigModify);
export default connect(mapStateToProps, actions)(extended);



// WEBPACK FOOTER //
// ./src/containers/LoraConfigModify.js